import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Label from './Input/Label'
import { Input as PicklistInput, Output as PicklistOutput } from './Picklist'
import { RadioButtonStyle } from './Radio/RadioButtonStyle'
import { v4 as uuid } from 'uuid'

class Radio extends Component {
  static propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    onValueChange: PropTypes.func,
    fieldType: PropTypes.string,
    value: PropTypes.string,
    radio: PropTypes.arrayOf(PropTypes.object)
  }
  static defaultProps = {
    disabled: false
  }
  radioId = 'radio_' + uuid()
  onChange = (e) => {
    const { onValueChange } = this.props
    const { value } = e.target
    onValueChange && onValueChange(this.normalizeValue(value))
  }

  normalizeValue = (value) => {
    if (value && value.toLowerCase() === 'true') {
      return true
    }
    if (value && value.toLowerCase() === 'false') {
      return false
    }
    return value
  }

  render () {
    const { label, disabled, value, picklist, radioAlignment } = this.props
    return (
      <div className={`radio-wrapper`}>
        {
          picklist && picklist.map((r, index) => (
            <div className={`custom-control custom-radio mr-3`} key={index}>
              <input
                type={`radio`}
                className={`custom-control-input`}
                disabled={disabled}
                name={this.radioId}
                value={r.value}
                onChange={this.onChange}
                checked={r.value === value}
                id={this.radioId + index}
              />
              <label htmlFor={this.radioId + index} className={`custom-control-label mb-0`}>{r.label}</label>
            </div>
          ))
        }
        <style jsx>{`
          .radio-wrapper {
            display: flex;
            flex-direction: ${radioAlignment === 'horizontal' ? 'row' : 'column'};
          }
          .radio-wrapper > .custom-radio > .custom-control-label::before {
            top: .15rem;
          }
          .radio-wrapper > .custom-radio > .custom-control-label::after {
            top: .15rem;
          }
        `}</style>
        <style jsx>{RadioButtonStyle}</style>
      </div>
    )
  }
}

export const Input = props => {
  const { isFormField, picklist } = props
  return (
    <div className={`w-100 input-wrapper`}>
      <Label {...props} />
      {
        isFormField
          ? <Radio {...props} onChange={props.onValueChange} />
          : <PicklistInput {...props} picklist={picklist} />
      }
    </div>
  )
}

export const Output = props => {
  const { isFormField, picklist } = props
  return (
    <div className={`w-100 input-wrapper`}>
      {
        isFormField
          ? <Radio {...props} onChange={props.onValueChange} disabled />
          : <PicklistOutput {...props} picklist={picklist} />
      }
    </div>
  )
}
